import { ReportstaffrevenueService } from 'src/services/reportstaffrevenue.service';
import { showToast } from 'src/utils/common';
import {
    DEFAULT_ROW_PER_PAGE,
  } from 'src/utils/constants';

import { AppAction } from './app.action';

export const REPORTSTAFFREVENUE_UPDATE_FILTER = 'REPORTSTAFFREVENUE:REPORTSTAFFREVENUE_UPDATE_FILTER'

export const REPORTSTAFFREVENUE_NEW_CARE_SUCCESS = 'REPORTSTAFFREVENUE:NEW_CARE_SUCCESS'
export const REPORTSTAFFREVENUE_LIST_SUCCESS = 'REPORTSTAFFREVENUE:FIND_ALL_SUCCESS'
export const REPORTSTAFFREVENUE_LIST_FAILD = 'REPORTSTAFFREVENUE:FIND_ALL_FAILD'
export const REPORTSTAFFREVENUE_COUNT_ASSIGN_SUCCESS = 'REPORTSTAFFREVENUE:COUNT_ASSIGN_SUCCESS'
export const REPORTSTAFFREVENUE_COUNT_ASSIGN_FAILD = 'REPORTSTAFFREVENUE:COUNT_ASSIGN_FAILD'

export const REPORTSTAFFREVENUE_CREATE_SUCCESS = 'REPORTSTAFFREVENUE:CREATE_SUCCESS'
export const REPORTSTAFFREVENUE_CREATE_FAILD = 'REPORTSTAFFREVENUE:CREATE_FAILD'

export const REPORTSTAFFREVENUE_IMPORT_SUCCESS = 'REPORTSTAFFREVENUE:IMPORT_SUCCESS'
export const REPORTSTAFFREVENUE_SAVE_SUCCESS = 'REPORTSTAFFREVENUE:SAVE_SUCCESS'
export const REPORTSTAFFREVENUE_SAVE_FAILD = 'REPORTSTAFFREVENUE:SAVE_SUCCESS'

export const REPORTSTAFFREVENUE_DEL_SUCCESS = 'REPORTSTAFFREVENUE:DEL_SUCCESS'
export const REPORTSTAFFREVENUE_DEL_FAILD = 'REPORTSTAFFREVENUE:DEL_FAILD'


export const REPORTSTAFFREVENUE_HISTORY_LIST_SUCCESS = 'REPORTSTAFFREVENUE:HISTORY_FIND_ALL_SUCCESS'
export const REPORTSTAFFREVENUE_HISTORY_LIST_FAILD = 'REPORTSTAFFREVENUE:HISTORY_FIND_ALL_FAILD'

export const REPORTSTAFFREVENUE_LIST_EXPORT_SUCCESS = 'REPORTSTAFFREVENUE:FIND_ALL_EXPORT_SUCCESS'
export const REPORTSTAFFREVENUE_LIST_EXPORT_FAILD = 'REPORTSTAFFREVENUE:FIND_ALL_EXPORT_FAILD'

export const ReportstaffrevenueAction = {
    list,
    listExport,
    findAssign,
    create,
    updateFilter,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    updateUser,
}


function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        ReportstaffrevenueService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTSTAFFREVENUE_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: REPORTSTAFFREVENUE_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { reportstaffrevenue } = getState()
        dispatch(AppAction.appLoading(true));
        ReportstaffrevenueService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...reportstaffrevenue.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTSTAFFREVENUE_LIST_SUCCESS, data } }
    function failure(error) { return { type: REPORTSTAFFREVENUE_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { reportstaffrevenue } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = reportstaffrevenue;
        
        ReportstaffrevenueService.findAll(filter.page, filter.limit, filter).then((rs) => {
            if (!!filter && filter.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count,
                    tongDoanhThuTamTinh: rs.data.tongDoanhThuTamTinh,
                    tongDoanhThuThucTe: rs.data.tongDoanhThuThucTe,
                    tongHoanTien: rs.data.tongHoanTien,
                    tongGoi: rs.data.tongGoi,
                }));
            } else {
                dispatch(success({
                    items: [...reportstaffrevenue.items, ...rs.data.values],
                    total: rs.data.count,
                    tongDoanhThuTamTinh: rs.data.tongDoanhThuTamTinh,
                    tongDoanhThuThucTe: rs.data.tongDoanhThuThucTe,
                    tongHoanTien: rs.data.tongHoanTien,
                    tongGoi: rs.data.tongGoi,
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTSTAFFREVENUE_LIST_SUCCESS, data } }
    function failure(error) { return { type: REPORTSTAFFREVENUE_LIST_FAILD, error } }
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { reportstaffrevenue } = getState();

            const { filter } = reportstaffrevenue;

            // Perform your asynchronous operation (e.g., API call)
            ReportstaffrevenueService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: REPORTSTAFFREVENUE_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: REPORTSTAFFREVENUE_LIST_EXPORT_FAILD, error } }
}

function updateFilter(payload) {
    return { type: REPORTSTAFFREVENUE_UPDATE_FILTER, data: payload }
}

function importData(payload) {
    return { type: REPORTSTAFFREVENUE_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            ReportstaffrevenueService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(ReportstaffrevenueAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: REPORTSTAFFREVENUE_SAVE_SUCCESS, data } }
    function failure(error) { return { type: REPORTSTAFFREVENUE_SAVE_FAILD, error } }
}

function update(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ReportstaffrevenueService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(ReportstaffrevenueAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTSTAFFREVENUE_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REPORTSTAFFREVENUE_CREATE_FAILD, error } }
}

function updateUser(username, track0, track1) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ReportstaffrevenueService.updateUser(username, track0, track1).then((rs) => {
            
        }).catch((error) => {
            
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function create(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ReportstaffrevenueService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(ReportstaffrevenueAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTSTAFFREVENUE_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REPORTSTAFFREVENUE_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ReportstaffrevenueService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(ReportstaffrevenueAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTSTAFFREVENUE_DEL_SUCCESS, data } }
    function failure(error) { return { type: REPORTSTAFFREVENUE_DEL_FAILD, error } }
}


function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ReportstaffrevenueService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(ReportstaffrevenueAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { reportstaffrevenue } = getState()
        dispatch(AppAction.appLoading(true));
        ReportstaffrevenueService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...reportstaffrevenue.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTSTAFFREVENUE_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: REPORTSTAFFREVENUE_HISTORY_LIST_FAILD, error } }
}